var $6b2f4f3846391353$exports = {};
$6b2f4f3846391353$exports = {
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`
};


export {$6b2f4f3846391353$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
